/**
 * Backend application error code for duplicate network rule (unique "uq_flow").
 * Prefer matching together with HTTP 409 — body codes are app-defined and may repeat across routes.
 */
export const API_ERROR_CODE_DUPLICATE_FLOW = 6;

export class ApiHttpError extends Error {
  readonly status: number;
  readonly apiCode?: number;
  readonly details: unknown;

  constructor(
    status: number,
    body: { code?: number; message?: string; details?: unknown },
  ) {
    super(body.message ?? `HTTP ${status}`);
    this.name = "ApiHttpError";
    this.status = status;
    this.apiCode = body.code;
    this.details = body.details ?? [];
  }

  /** Duplicate flow / rule — backend: 409 + code 6 + uq_flow constraint */
  isDuplicateFlowConflict(): boolean {
    return (
      this.status === 409 && this.apiCode === API_ERROR_CODE_DUPLICATE_FLOW
    );
  }

  override toString(): string {
    return this.message;
  }
}

export function resolveApiNotifyText(
  err: unknown,
  translate: (key: string) => string,
): string {
  if (err instanceof ApiHttpError && err.isDuplicateFlowConflict()) {
    return translate("hosts.flows.errors.duplicateRule");
  }
  if (err instanceof ApiHttpError) {
    return resolveApiNotifyText(err.message, translate);
  }
  if (typeof err === "string") {
    if (err === "forbidden delete not allowed flow") {
      return translate("hosts.flows.errors.deleteForbidden");
    }
    return err;
  }
  if (err && typeof err === "object" && "message" in err) {
    const m = (err as { message: unknown }).message;
    return resolveApiNotifyText(typeof m === "string" ? m : String(m), translate);
  }
  return String(err);
}
